import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import WorkItemsSchema from 'schemas/workitemsType.schema.json';
import { useAppContext } from 'hooks/useAppContext';
import {useFormContext} from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';

const AssignWorkItemType = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties, updateWorkItemsType }) => {

    const { selectedProjectData } = useAppContext();
    const formContext = useFormContext();

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(WorkItemsSchema);
    })

    const onSubmit = async (values) => {
        let result;
        if (CRUDType === "INSERT") {
            result = await updateWorkItemsType(values);
            setTimeout(callback, 1000);
        } 
        return result;
    };
    return selectedProjectData && formContext.ready ? 
    withExtension(DynamicForm, { schema: WorkItemsSchema, orientation, onSubmit, defaultValues, disabledProperties, hiddenProperties, definitions: formContext.definitions }) :
    <SkeletonForm />
}



AssignWorkItemType.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

AssignWorkItemType.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}


export default AssignWorkItemType
